function formatAMPM(date, showSec = true) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const sec = date.getSeconds();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  let strTime = addZero(hours) + ':' + minutes + ':'    + addZero(sec)+' ' + ampm;
  if (!showSec) strTime = addZero(hours) + ':' + minutes +' ' + ampm;
  return strTime;
}
function addZero(i) {
  if (i < 10) {
    i = `0${i}`;
  }
  return i;
}

const convert24Hours = (time) => {
  let hours = Number(time.match(/^(\d+)/)[1]);
  let minutes = Number(time.match(/:(\d+)/)[1]);
  const AMPM = time.match(/\s(.*)$/)[1];
  if(AMPM === "PM" && hours<12) hours = hours+12;
  if(AMPM === "AM" && hours===12) hours = hours-12;
  if(AMPM === "pm" && hours<12) hours = hours+12;
  if(AMPM === "am" && hours===12) hours = hours-12;
  let sHours = hours.toString();
  let sMinutes = minutes.toString();
  if(hours<10) sHours = "0" + sHours;
  if(minutes<10) sMinutes = "0" + sMinutes;
  return sHours + "." + sMinutes;
}

let formatDate = (date, option = 'datetime', format='Y-m-d') => {
  var d = new Date(date);
    d.setHours(d.getHours()+2);  // added hours for EST adjustment
  var month = '' + addZero(d.getMonth() + 1,2),
    day = '' + addZero(d.getDate(),2),
    year = d.getFullYear(),
    hours = addZero(d.getHours(),10),
    minutes = addZero(d.getMinutes(),10),
    seconds = addZero(d.getSeconds(),10);
  let dateSt = '';
  if (format==='Y-m-d') {
    dateSt = [year, month, day].join('-');
  } else {
    if (format==='m/d/y') dateSt = [month, day, year].join('/');
  }
  
  let retDate = `${dateSt}`;
  if (option === 'datetime') {
    let time = [hours, minutes, seconds].join(':');
    retDate = `${dateSt} ${time}`;
  }
  return retDate;
}

export {formatDate, formatAMPM, convert24Hours };